const ROOM_ACCESS_CATEGORY_ID = 506;

export const filterNdmExperienceCategories = <T extends { id: number }>(
  categories: T[],
  currentCategoryId?: number | null
): T[] =>
  categories.filter(
    (category) =>
      category.id !== ROOM_ACCESS_CATEGORY_ID ||
      category.id === currentCategoryId
  );
